// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2WbuL","consentsList":"PatientConsents_consentsList__bVB4t","consentsListEmpty":"PatientConsents_consentsListEmpty__3UKzb"};